/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';

const GetAllTrimClips = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getAllTrimClips.url,
        maverickPortalApiEndPoint.getAllTrimClips.methodType,
        data
      )
      .then(response => {
        const res = response.data;
        resolve({ res });
      });
  });
};

export { GetAllTrimClips };
